import axios from "axios"
import global from "../../globalvar";

async function createLotLog(lotlog) {
    return (await axios.post(global.ApiBaseUrl +"/api/lotlog/create", lotlog, {
        headers: {
            "x-auth-token": JSON.parse(localStorage.getItem("authInfo")).token
        }
    }))
}
async function updateLotLog(lotlog) {
    return (await axios.put(global.ApiBaseUrl +"/api/lotlog/" + lotlog._id + "/edit", lotlog, {
        headers: {
            "x-auth-token": JSON.parse(localStorage.getItem("authInfo")).token
        }
    }))
}

export default {
    createLotLog,
    updateLotLog
}